import { log } from "../../../utils/log.ts";
import { checkIfTokenIsNeedingUpdate } from "../tokenUpdateStrategy";

export const overrideXHR = () => {
  log("overrideXHR iniciado");
  const OriginalXHR = window.XMLHttpRequest;

  const originalOpen = OriginalXHR.prototype.open;
  const originalSend = OriginalXHR.prototype.send;

  OriginalXHR.prototype.open = function (...args) {
    (this)._url = args[1];
    originalOpen.apply(this, args);
  };

  OriginalXHR.prototype.send = function (body) {
    const url = (this)._url;
    const isBFFGraphQL = url?.includes(process.env.BFF_URL)
    const bodyStr = typeof body === "string" ? body : undefined;

    if (this.setRequestHeader && isBFFGraphQL && bodyStr) {
      checkIfTokenIsNeedingUpdate(bodyStr).then((newToken) => {
        if (newToken) {
          this.setRequestHeader("Authorization", `Bearer ${newToken}`);
          log("Substituindo Authorization em XHR por token renovado");
        }
        originalSend.call(this, body);
      });
    } else {
      originalSend.call(this, body);
    }
  };
};
